import type { IServiceDTO } from '@sales-center/common'
import type { ILeadOppProduct } from '@user/store/leadOppProducts'
import { IServiceProduct } from '@user/store/serviceProducts/typings'

export const createSystemOpportunityName = (
  services: ILeadOppProduct[] | IServiceDTO[] | IServiceProduct[],

  maxLength: number = 100,
): string => {
  const uniqueServiceCodes: string[] = [
    ...new Set(
      services.map((x) =>
        x.name && x.name.trim().length > 0 ? x.name : x.description,
      ),
    ),
  ]
  const servicesText: string =
    services.length > 0
      ? uniqueServiceCodes.join(', ')
      : 'Service codes will appear here'
  return `${servicesText.substring(0, maxLength)}`
}

export const createSystemOpportunityNameUI = (
  contactName: string,
  services: ILeadOppProduct[],
  maxLength: number = 100,
): string => {
  const uniqueServiceCodes: string[] = [...new Set(services.map((x) => x.name))]
  const servicesText: string = uniqueServiceCodes.join(', ')
  return `${contactName} - ${servicesText}`.substring(0, maxLength)
}
